import "../css/style.scss"

// Our modules / classes
import Search from "./modules/Search"

const search = new Search()

if (window.jQuery) {
  jQuery(document).ready(function ($) {
    setTimeout(function () {
      const defaultSource = $("audio.player11069 source").attr("src");
      const audioPlayer = $("audio.player11069")[0];
      const playerTitle = $("#player-title");
      const listenButton = $("#listen-to-radio");
      const playButtonControl = $(".plyr__controls__item.plyr__control");
      const episodePlayButtons = $(".play-button");
      const equalizer = $(".equalizer"); // Assuming the equalizer has this class

      // Load saved state
      const storedSrc = localStorage.getItem("player_src") || defaultSource;
      const storedTitle = localStorage.getItem("player_title") || samaData.default_radio_title;
      const storedStatus = localStorage.getItem("player_status") || "paused";
      const storedMp3Url = localStorage.getItem("player_mp3url");
      const storedPlaybackTime = parseFloat(localStorage.getItem("current_playback_time")) || 0;

      // Apply stored player values
      $("audio.player11069 source").attr("src", storedSrc);
      audioPlayer.load();
      playerTitle.html(storedTitle);

      // Set the playback time to the stored value (if applicable)
      audioPlayer.currentTime = storedPlaybackTime;

      // Restore play state if playing (autoplay fallback handled)
      // if (storedStatus === "playing") {
      //   audioPlayer.addEventListener("canplaythrough", function onReady() {
      //     audioPlayer.removeEventListener("canplaythrough", onReady);
      //     audioPlayer.play().catch(err => {
      //       console.warn("Autoplay blocked:", err);
      //       localStorage.setItem("player_status", "paused");
      //     });
      //   });
      // }


      let hasAutoplayed = false; // Prevent multiple autoplay attempts

if (storedStatus === "playing") {
  const onReady = function () {
    if (!hasAutoplayed) {
      hasAutoplayed = true;
      audioPlayer.play().catch(err => {
        console.warn("Autoplay blocked:", err);
        localStorage.setItem("player_status", "paused");
      });
    }
    audioPlayer.removeEventListener("canplaythrough", onReady);
  };
  audioPlayer.addEventListener("canplaythrough", onReady);
}




      // Update the current class for episode items based on the stored data
      $(".episode-item").removeClass("playing-now paused-now");
      if (storedMp3Url) {
        const targetItem = $(`.play-button[data-mp3url="${storedMp3Url}"]`).closest(".episode-item");
        targetItem.addClass(storedStatus === "playing" ? "playing-now" : "paused-now");
      }

      // Save play/pause state
      audioPlayer.addEventListener("play", function () {
        localStorage.setItem("player_status", "playing");
        const currentItem = $(`.play-button[data-mp3url="${storedMp3Url}"]`).closest(".episode-item");
        currentItem.removeClass("paused-now").addClass("playing-now");

        // Show equalizer when playing
        equalizer.show();
      });

      audioPlayer.addEventListener("pause", function () {
        localStorage.setItem("player_status", "paused");
        const currentItem = $(`.play-button[data-mp3url="${storedMp3Url}"]`).closest(".episode-item");
        currentItem.removeClass("playing-now").addClass("paused-now");

        // Hide equalizer when paused
        equalizer.hide();
      });

      // Listen to radio button
      listenButton.on("click", function () {
        $("audio.player11069 source").attr("src", defaultSource);
        audioPlayer.load();
        playerTitle.html(samaData.default_radio_title);

        localStorage.setItem("player_src", defaultSource);
        localStorage.setItem("player_title", samaData.default_radio_title);
        localStorage.setItem("player_status", "playing");
        localStorage.removeItem("player_mp3url");

        $(".episode-item").removeClass("playing-now paused-now");

        audioPlayer.play().catch(err => {
          console.warn("Playback interrupted:", err);
        });
      });

      // Fallback in case radio is not playing
      playButtonControl.on("click", function () {
        const isPlaying = playButtonControl.hasClass("plyr__control--pressed");
        const currentSource = $("audio.player11069 source").attr("src");

        if (currentSource === defaultSource && !isPlaying) {
          listenButton.trigger("click");
        }
      });

      // Play episode
      episodePlayButtons.on("click", function () {
        const mp3Url = $(this).data("mp3url");
        const episodeTitle = $(this).data("title");

        if (!mp3Url) return;

        // Remove status classes from all episode items
        $(".episode-item").removeClass("playing-now paused-now");

        // Add 'playing-now' to the clicked episode item
        const $episodeItem = $(this).closest(".episode-item");
        $episodeItem.addClass("playing-now");

        // Update audio source and UI
        $("audio.player11069 source").attr("src", mp3Url);
        audioPlayer.load();
        playerTitle.html(episodeTitle);

        // Save to local storage
        localStorage.setItem("player_src", mp3Url);
        localStorage.setItem("player_title", episodeTitle);
        localStorage.setItem("player_status", "playing");
        localStorage.setItem("player_mp3url", mp3Url);

        // Play audio
        audioPlayer.play().catch(err => {
          console.warn("Episode playback error:", err);
        });
      });

      // Sync class with player state (play/pause)
      audioPlayer.addEventListener("play", function () {
        const currentMp3 = localStorage.getItem("player_mp3url");

        $(".episode-item").removeClass("playing-now paused-now");

        if (currentMp3) {
          $(`.play-button[data-mp3url="${currentMp3}"]`)
            .closest(".episode-item")
            .addClass("playing-now");
        }

        // Show equalizer when playing
        equalizer.show();
      });

      audioPlayer.addEventListener("pause", function () {
        const currentMp3 = localStorage.getItem("player_mp3url");

        $(".episode-item").removeClass("playing-now paused-now");

        if (currentMp3) {
          $(`.play-button[data-mp3url="${currentMp3}"]`)
            .closest(".episode-item")
            .addClass("paused-now");
        }

        // Hide equalizer when paused
        equalizer.hide();

audioPlayer.addEventListener("pause", function () {
  const currentMp3 = localStorage.getItem("player_mp3url");

  $(".episode-item").removeClass("playing-now paused-now");

  if (currentMp3) {
    $(`.play-button[data-mp3url="${currentMp3}"]`)
      .closest(".episode-item")
      .addClass("paused-now");
  }
});

// Pause player when modal is closed
$(".modal").on("hidden.bs.modal", function () {
  if (!audioPlayer.paused) {
    audioPlayer.pause();
    localStorage.setItem("player_status", "paused");

    const currentMp3 = localStorage.getItem("player_mp3url");
    if (currentMp3 && currentMp3 !== defaultSource) {
      const $targetItem = $(`.play-button[data-mp3url="${currentMp3}"]`).closest(".episode-item");
      $targetItem.removeClass("playing-now").addClass("paused-now");
      $targetItem.find(".equalizer").hide();
    }
  }
});

      });

      // Update current playback time in localStorage, but only if the src is not the default
      audioPlayer.addEventListener("timeupdate", function () {
        const currentSrc = $("audio.player11069 source").attr("src");
        if (currentSrc !== defaultSource) {
          localStorage.setItem("current_playback_time", audioPlayer.currentTime);
        }
      });

      $(".open-youtube-video").on("click", function () {
        if (!audioPlayer.paused) {
          audioPlayer.pause();

          const currentMp3 = localStorage.getItem("player_mp3url");
          const currentSrc = $("audio.player11069 source").attr("src");

          localStorage.setItem("player_status", "paused");

          $(".episode-item").removeClass("playing-now paused-now");

          if (currentMp3) {
            const $targetItem = $(`.play-button[data-mp3url="${currentMp3}"]`).closest(".episode-item");
            $targetItem.addClass("paused-now");

            // Hide equalizer (if exists)
            $targetItem.find(".equalizer").hide();
          }

          // Save playback time only if it's not the default stream
          if (currentSrc !== defaultSource) {
            localStorage.setItem("current_playback_time", audioPlayer.currentTime);
          }
        }
      });


    }, 1500);


    // accordion in team archive page

    let showHideOldPresentersBtn = $("#showHideOldPresenters");
    showHideOldPresentersBtn.on("click", function(){
      $("#oldPresentersContainer").slideToggle(300);
    })


  });
} else {
  console.warn("jQuery is not loaded!");
}


/*
// snow.js - for Christmas season - optimized for performance
(function() {
  // Only run if the body has the class "christmas-season"
  if (!document.body.classList.contains('christmas-season')) return;

  const snowContainer = document.createElement('div');
  snowContainer.id = 'snow-overlay';
  snowContainer.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: 1;';
  document.body.appendChild(snowContainer);

  const snowChars = ['❄','❅','❆'];
  const density = 800; // Increased interval for better performance (was 200ms)
  const maxSnowflakes = 15; // Limit concurrent snowflakes
  const lifetime = 8000; // Reduced lifetime (was 10000ms)
  let activeSnowflakes = 0;

  function createSnowflake() {
    // Don't create more snowflakes if we've reached the limit
    if (activeSnowflakes >= maxSnowflakes) return;

    activeSnowflakes++;
    const snowflake = document.createElement('div');
    snowflake.className = 'snowflake';
    snowflake.textContent = snowChars[Math.floor(Math.random() * snowChars.length)];

    // Optimize style setting
    snowflake.style.cssText = `
      position: absolute;
      left: ${Math.random() * 100}vw;
      top: -10px;
      font-size: ${Math.random() * 12 + 8}px;
      opacity: ${Math.random() * 0.6 + 0.4};
      animation: snowfall ${Math.random() * 3 + 4}s linear;
      pointer-events: none;
      user-select: none;
    `;

    snowContainer.appendChild(snowflake);

    // cleanup with counter decrement
    setTimeout(() => {
      if (snowflake.parentNode) {
        snowflake.parentNode.removeChild(snowflake);
      }
      activeSnowflakes--;
    }, lifetime);
  }

  // Start snow creation
  const snowInterval = setInterval(createSnowflake, density);

  // Add CSS animation if not exists
  if (!document.getElementById('snowfall-animation')) {
    const style = document.createElement('style');
    style.id = 'snowfall-animation';
    style.textContent = `
      @keyframes snowfall {
        0% { transform: translateY(-10px); }
        100% { transform: translateY(100vh); }
      }
      .snowflake {
        color: #fff;
        text-shadow: 0 0 5px rgba(255,255,255,0.5);
        font-family: Arial, sans-serif;
      }
    `;
    document.head.appendChild(style);
  }

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    clearInterval(snowInterval);
    if (snowContainer.parentNode) {
      snowContainer.parentNode.removeChild(snowContainer);
    }
  });
})();
*/

